import styled from 'styled-components';
import type { BackgroundValue } from '@elfsight/configurator-contracts';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { useTranslation } from 'react-i18next';
import { getInvertedColorFromBackground } from '../utils';

const DEFAULT_COLOR = '#878787';

const getMessageColor = (background: BackgroundValue) => {
  const { type, color } = background;

  if (type === 'color' && color === 'transparent') {
    return DEFAULT_COLOR;
  }

  return getColorWithAlpha(getInvertedColorFromBackground(background), 0.5);
};

export function EmptyState() {
  const { t } = useTranslation();
  const { widgetBackground } = useSettings();
  const messageColor = getMessageColor(widgetBackground);

  return (
    <Message $textColor={messageColor}>
      {t('No jobs found. Try adjusting your filters or search term.')}
    </Message>
  );
}

const Message = styled(Typography)<{ $textColor: string }>`
  margin-top: 20px;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: ${({ $textColor }) => $textColor};
`;
